const frontPage = () => {
    // Services bottom
    let serviceBottom = document.querySelector(".service__bottom");
    if (serviceBottom) {
        const serviceBottomTl = gsap.timeline({
            scrollTrigger: {
                trigger: serviceBottom,
                start: "0 70%",
            },
        });

        serviceBottomTl
            .from(".service__bottom--icon div", {
                y: 50,
                opacity: 0.5,
                duration: 0.5,
                stagger: 0.2,
            })
            .from(
                ".service__bottom--title div",
                {
                    y: 25,
                    duration: 0.75,
                    ease: "power1.out",
                    stagger: 0.2,
                },
                "<"
            )
            .from(
                ".service__bottom--content",
                {
                    y: 25,
                    opacity: 0,
                    duration: 1,
                    ease: "power1.out",
                    stagger: 0.2,
                },
                "<"
            );
    }

    // SEO
    let seo = document.querySelector(".seo");
    if (seo) {
        const seoTl = gsap.timeline({
            scrollTrigger: {
                trigger: seo,
                start: "0 70%",
            },
        });

        seoTl
            .to(".seo__city--mask", {
                ease: "power3.out",
                width: "100%",
                duration: 1,
                stagger: 0.1,
            })
            .to(".seo__city--name", {
                opacity: 1,
            })
            .to(".seo__city--mask", {
                ease: "power2.in",
                top: "100%",
                duration: 0.5,
                stagger: 0.1,
            });
    }
};

export default frontPage;
